import { atom } from 'recoil';

export const surveyMenuIdAtom = atom({
  key: 'surveyMenuIdAtom',
  default: localStorage.getItem('surveyMenuId') ?? 0,
});
